module.exports = __webpack_public_path__ + "c891b1f24e7bbfec1a4685ecd3c99b2f.svg";